import type { PresentationIsEmptyProps } from '../..'
export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const cards = block?.fields?.cards

  if (cards.length === 0) return true

  return false
}
